import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-order-details-skeleton',
  templateUrl: './order-details-skeleton.component.html',
  styleUrls: ['./order-details-skeleton.component.scss'],
  standalone: false
})
export class OrderDetailsSkeletonComponent {
  // When true only the order rows table is rendered (used while the rows are loading after the order header)
  @Input() onlyRows = false;

  // Details / Total columns, each with three label-value lines
  detailColumnArray = [0, 1];
  detailArray = [0, 1, 2];
  rowArray = [0, 1, 2, 3, 4];
  // Columns after the description (qty, unit price, discount, total, delivery date)
  columnArray = [0, 1, 2, 3, 4];
}
